export const directGoalSelfFn = ({ entity, scope }) => {
  if (scope.isEmpty) {
    return false;
  }

  const relations = scope.relations || [];
  if (relations.length === 0) {
    return true;
  }

  return relations.some((r) => entity.uid === r.uid);
};
